import { isNotEmptyArray, isNotNullOrUndefined } from '@vy/utils';
import type { PlanAssignmentCustomerData } from '../../plans-page-types/plan-assignment-customer-data-schema';

export function validateCreateContractStep(
  stepToValidate: number,
  selectedCustomers: PlanAssignmentCustomerData[],
  startDate: Date | undefined,
) {
  switch (stepToValidate) {
    case 0:
      return isNotEmptyArray(selectedCustomers);
    case 1:
      return isNotNullOrUndefined(startDate);
    default:
      throw new Error(`Invalid step ${stepToValidate}`);
  }
}
